import * as $ from 'jquery';
import * as Masonry from 'masonry-layout';


export class CardSectionService {

    static cardsHeightFix(root) {
        $(root).find('.card-item:not(".random-height, .news-item, .contact-item")').each(function (i, e) {
            var elem = $(e);
            var width = elem.width();

            elem.height(width);

            if (elem.hasClass('medium')) {
                elem.height((width / 2) - 4);
            }

            if (elem.hasClass('reference')) {
                elem.height((width * 0.6246913580246914) - 4);
            }

            if (elem.hasClass('reference-image')) {
                if (elem.hasClass('big')) {
                    elem.height((width * 0.6188118811881188) + 2);
                } else {
                    elem.height((width * 0.6188118811881188));
                }
            }

            // RELATED PRODUCTS SLIDER
            if (elem.parents().hasClass('related-products')) {
                if ($(window).width() >= 960) {
                    var carouselWidth = $('.related-products').width();
                    var carouselHeight = (carouselWidth - 24) / 4;

                    if (elem.hasClass('small')) {
                        elem.width((carouselWidth - 24) / 4);
                        elem.height(carouselHeight);
                    } else if (elem.hasClass('medium')) {
                        elem.width((carouselWidth - 8) / 2);
                        elem.height(carouselHeight);
                    }
                } else if ($(window).width() >= 600 && $(window).width() <= 959) {
                    var carouselWidth = $('.related-products').width();
                    var carouselHeight = (carouselWidth - 8) / 2;

                    if (elem.hasClass('small')) {
                        elem.width((carouselWidth - 8) / 2);
                        elem.height(carouselHeight);
                    } else if (elem.hasClass('medium')) {
                        elem.width((carouselWidth - 8) / 2);
                        elem.height(carouselHeight);
                    }
                } else if ($(window).width() < 599) {
                    var carouselWidth = $('.related-products').width();

                    elem.width(carouselWidth);
                    elem.height(carouselWidth);
                }
            }
        });
    }

    static getSortedCardsHtml(renderedCards: Array<string>, cardIds: Array<number>) {
        let ids = cardIds.map(id => +id);
        return renderedCards.sort((c1, c2) => ids.indexOf(+$(c1).attr('data-card-id')) - ids.indexOf(+$(c2).attr('data-card-id')))
            .reduce((prev, curr) => prev + curr, '');
    }

    static initSection(selector?) {
        
        let sections;
        if (selector)
            sections = $(selector);
        else
            sections = $('.dnd-editor-parent .card-section-component, .dnd-editor-parent .boxes-component, .dashboard-container .grid.dashboard');
        sections.each((i, node) => {
            CardSectionService.cardsHeightFix(node);
            let section = $(node);
            section.find('.grid-item').find('.inner').fadeIn();
            if (section.find('.grid-item.small:not(.hidden)').length > 0) {
                new Masonry(section.find('.grid').get(0), {
                    // $(section.find('.grid')).masonry( {
                    itemSelector: '.grid-item',
                    columnWidth: '.small:not(.hidden)'
                });
            }
            else {
                if (section.find('.grid-item.medium:not(.hidden)').length > 0) {
                    new Masonry(section.find('.grid').get(0), {
                        itemSelector: '.grid-item',
                        columnWidth: '.medium:not(.hidden)'
                    });
                }
                else {
                    new Masonry(section.find('.grid').get(0), {
                        itemSelector: '.grid-item',
                        columnWidth: '.big:not(.hidden)'
                    });
                }
            }
        });

    }
}
/*
export class CardOrganizer {

    private card;
    private grid;

    public saveCards() {
        var submitUrl = $('.grid').closest('form').attr('action');
        var formData = new FormData();
        var order = this.getOrder();
        order.forEach(function (item) {
            formData.append('assigned_cards[]', item);
        })
        $.ajax({
            url: submitUrl,
            data: formData,
            cache: false,
            contentType: false,
            processData: false,
            method: 'POST'
        });
    }


    public initEditor() {

        CardSectionService.cardsHeightFix();
        $('.card-organizer .grid-item').find('.inner').fadeIn();
        if ($('.card-organizer .grid-item.small:not(.hidden)').length > 0) {
            this.grid = $('.card-organizer .grid').packery({
                itemSelector: '.grid-item',
                columnWidth: '.small:not(.hidden)',
                //horizontal: true,
            });
        }
        else {
            this.grid = $('.card-organizer .grid').packery({
                itemSelector: '.grid-item',
                columnWidth: '.medium:not(.hidden)',
                //horizontal: true,
            });
        }

        this.grid.find('.grid-item').each(function (i, gridItem) {
            $(gridItem).find('.inner').append($('<div class="delete-btn"><i class="fa fa-trash-o"></i></div>'));
            var draggie = new Draggabilly(gridItem);
            this.grid.packery('bindDraggabillyEvents', draggie);
            draggie.on('dragEnd', function (event, pointer) {
                let order = this.getOrder();
                this.saveCards();
            })
        });


        this.grid.on('click', '.grid-item .delete-btn', function () {
            this.grid.packery('remove', $(this).closest('.grid-item').get(0))
                .packery();
            this.saveCards();
        });

        $(window).resize(CardSectionService.cardsHeightFix);
    }



    private getOrder() {
        var order = [];
        var elements = this.grid.packery('getItemElements');
        $(elements).each(function (i, el) {
            order.push($(el).attr('data-card-id'));
        });
        return order;
    }




    // function setOrder() {
    //     var order = localStorage.getItem('card-order');
    //     var items = $('.grid-item');
    //     $(items).remove();
    //     var arr = items.toArray();

    //     arr.sort(function (a, b) {
    //         return (order.indexOf($(a).attr('data-card-id')) - order.indexOf($(b).attr('data-card-id')));
    //     });

    //     var grid = $('.grid');
    //     arr.forEach(function (el) {
    //         grid.append(el);
    //     });
    // }

    //setOrder();


*/
